import React, { FC, useEffect } from 'react';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useRecoilValue } from 'recoil';

import { userSettingsState } from '@store';

import { segmentEventTypes } from '../components/segment/segmentEventTypes';
import { segmentTrackEvent } from '../components/segment/SegmentTrackEvent';

const deleteObjectProperties = (_object, _properties) => {
  for (const p of _properties) {
    p in _object && delete _object[p];
  }
  return _object;
};

// Component that wraps the children prop with the axios interceptors
export const WithAxios: FC = ({ children }) => {
  const userSettings = useRecoilValue(userSettingsState);

  useEffect(() => {
    // Return response by default, nothing changes
    const resInterceptor = (response: AxiosResponse) => response;

    // Catch all axios errors and send Error Log event to segment
    const errInterceptor = (error: AxiosError) => {
      const { data } = error.config || {};
      const { status, responseURL, response } = error.request || {};

      const payload = data ? JSON.stringify(deleteObjectProperties(JSON.parse(data), ['client_id'])) : null;

      const apiErrorData = {
        source: responseURL,
        payload,
        responseCode: status,
        response,
      };

      segmentTrackEvent(segmentEventTypes.ERROR_LOG, userSettings, {
        apiErrorData,
      });
      return Promise.reject(error);
    };

    const interceptor = axios.interceptors.response.use(resInterceptor, errInterceptor);

    return () => axios.interceptors.response.eject(interceptor);
  }, [userSettings]);

  return <>{children}</>;
};
